/*
 save map position in vuex, and react to changes
*/

import * as actions from '@/constants/actions';

export default {
    computed: {
        mapCenter() {
            return this.$store.state.map.center;
        },
    },
    methods: {
        /**
         * set the map position in vuex
         */
        async setMapStatePosition() {
            const map = await this.mapPromise;
            const center = map.getCenter();
            this.$store.dispatch(actions.SET_MAP_CENTER, center);
        },
    },
    watch: {
        // re-center map if map.center changes in vuex
        async mapCenter(center) {
            const map = await this.mapPromise;
            const localCenter = map.getCenter();
            if (center.zoom) map.setZoom(center.zoom);
            const { lat, lng } = center;
            if (localCenter.lat === lat && localCenter.lng === lng) {
                return;
            }

            try {
                map.setCenter([lng, lat]);
            } catch (e) {
                this.$store.dispatch(actions.SET_TOAST_TEXT, e.message);
                this.$store.dispatch(actions.SHOW_TOAST);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/mapStatePosition.js